import FieldCard from "./FieldCard";
import drag_img from '../../assets/images/drag.svg'
import { forwardRef } from "react";


export const DraggableFieldCard = forwardRef(
  ({ t, f, k, dragHandleProps, snapshot, handleUpdateField, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className="field_element"
        key={k}
      >
          <img src={drag_img} className="mx-auto d-block" {...dragHandleProps} />
          <FieldCard t={t} field={f} Ekey={k} handleUpdateField={handleUpdateField} />
      </div>
    );
  }
); 

export const DraggableFields = forwardRef(
  ({ children, ...props }, ref) => {
    return (
      <div ref={ref} className="fields">
        {children}
      </div>
    );
  }
); 